import * as $ from 'jquery';

import 'etc/designs/base/clientlibs/shared/libraries/SCS.Url.js';

import { Count, Service } from '../SocialMedia';

type Callback = [
	Disqus,
	(value : Count | PromiseLike<Count>) => void,
	(reason : any) => void
];

interface Callbacks {
	[url : string] : Callback;
}

const COUNT_URL = 'https://swisscomstorys.disqus.com/count-data.js';

function dispatchRequest() {
	const params : string[] = [];
	const handlers : Callback[] = [];

	// Data to be used below
	for (const url in callbacks) {
		params.push('2=' + encodeURI(url));
		handlers.push(callbacks[url]);
	}
	// Do request
	$.ajax({
		// Reject all handlers
		error(err) {
			for(const handler of handlers) {
				handler[2].call(handler[0], err);
			}
		},
		// Just load a script; hardcoded jsonP call
		dataType: 'script',
		// Create url
		url: [
			COUNT_URL, '?',
			params.join('&'),
		].join(''),
		// Check if handler was called
		success(data) {
			if (dispatched) {
				for(const handler of handlers) {
					handler[2].call(handler[0], data);
				}
			}
		},
	});
}

// Set up disqus jsonp
(window as any).DISQUSWIDGETS = {
	displayCount(data : any) {
		dispatched = false;
		if (typeof data === 'object' && typeof data.text === 'object') {
			const counts = data.counts as {id : string; comments : number}[];
			for(const countObj of counts) {
				const {id: url, comments} = countObj;
				const callback = callbacks[url];
				if(!callback) {
					continue;
				}
				callback[1].call(callback[0], {count: comments, id: url});
			}
		}
		// Dispatch more requests as long as we’re waiting for them
		if (dispatched) {
			dispatchRequest();
		} else {
			// Make sure we have no more pending callbacks
			// Resolve them with zero counts, since this happens
			// …whenever disqus is queried for urls it doesn't know
			for (const url in callbacks) {
				callbacks[url][1].call(callbacks[url][0], {id: url, count: 0});
			}
		}
	},
};

const callbacks : Callbacks = {};
let dispatched : number | boolean = false;

function shareUrl() : string {
	throw new Error('Disqus does not support sharing');
}

export class Disqus implements Service {
	public name = 'disqus';
	public category = ['commentCount'];

	public shareUrl = shareUrl;

	public shareCount(url : string) {
		url = SCS.Url.stripPathPrefixFromUrl(url);

		// Create the main promise for this getter
		return new Promise<Count>((resolve, reject) => {
			// Add this request to our queued items
			callbacks[url] = [this, resolve, reject];
			// Register deferred call once to start the requests
			// We have to dispatch requests in sequence
			if (!dispatched) {
				dispatched = window.setTimeout(dispatchRequest, 0);
			}
		});
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/generic/socialmedia/services/Disqus.ts